import React, { useEffect, useState } from 'react'
import { checkMoney, convertIdentifiers } from '../utils/configData';
import { useTranslation } from 'react-i18next';

function Preview({ errorShake, exchangeValue, change, selectedCoin, cryptoHubFee, closePopupPreview, pair, minTransac, selectedCurr, bankWalletsInfo, cryptoWalletsInfo, preview, userInfo, minimumEuros, handleExchange }) {
    const { t } = useTranslation();
    const [giveImg, setGiveImg] = useState("");
    const [receiveImg, setReceiveImg] = useState("");
    useEffect(() => {
        setGiveImg(checkMoney(preview[1]).img)
        setReceiveImg(checkMoney(preview[4]).img)
    }, [preview])

    return (
        <div className={`view-details ${errorShake ? 'shake' : ''}`}>
            <button onClick={closePopupPreview} className="close-popup">
                <i className="ri-close-line"></i>
            </button>
            <h3>{t("Is everything correct?")}</h3>
            <div className="wrapper-list">
                <div className="wrapper-list__item">
                    <h4>{t("Pay with")}</h4>
                    <div className="wallet">
                        {bankWalletsInfo.map((element) => {
                            if (element.key === preview[0]) {
                                return (
                                    <div key={element.key}>
                                        <h3>{userInfo.fname + " " + userInfo.lname}</h3>
                                        <p>{`${element.curr.toUpperCase()} 
                      (${element.type.toUpperCase()}) ${t(
                                            "ending in"
                                        )} ${element.iban.slice(-4)}`}</p>
                                    </div>
                                );
                            }
                            return null;
                        })}

                        {cryptoWalletsInfo.map((element) => {
                            if (element.key === preview[0]) {
                                return (
                                    <div key={element.key}>
                                        <h3>{element.name}</h3>
                                        <p>{`${element.curr.toUpperCase()
                                            } ${convertIdentifiers(element.type.toUpperCase())} ${t(
                                                "ending in"
                                            )} ${element.num.slice(-4)}`}</p>
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>
                </div>
                <div className="line-p"></div>
                <div className="wrapper-list__item">
                    <h4>{t("Receive on")}</h4>
                    <div className="wallet">
                        {bankWalletsInfo.map((element) => {
                            if (element.key === preview[3]) {
                                return (
                                    <div key={element.key}>
                                        <h3>{userInfo.fname + " " + userInfo.lname}</h3>
                                        <p>{`${element.curr.toUpperCase()} 
                      (${element.type.toUpperCase()}) ${t(
                                            "ending in"
                                        )} ${element.iban.slice(-4)}`}</p>
                                    </div>
                                );
                            }
                            return null;
                        })}

                        {cryptoWalletsInfo.map((element) => {
                            if (element.key === preview[3]) {
                                return (
                                    <div key={element.key}>
                                        <h3>{element.name}</h3>
                                        <p>{`${element.curr.toUpperCase()
                                            } ${convertIdentifiers(element.type.toUpperCase())} ${t(
                                                "ending in"
                                            )} ${element.num.slice(-4)}`}</p>
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>
                </div>
                <div className="line-p"></div>
                <div className="wrapper-list__item">
                    <h4>{t("Give (without fee)")}</h4>
                    <p>
                        <img
                            src={giveImg}
                            alt=""
                        />{" "}
                        {preview[2]}
                    </p>
                </div>
                <div className="line-p"></div>
                <div className="wrapper-list__item">
                    <h4>{t("Fee")}</h4>
                    <p><img
                        src={change ? selectedCurr.img : selectedCoin.img}
                        alt=""
                    />{" "}
                        {cryptoHubFee}</p>
                </div>
                <div className="line-p"></div>

                <div className="wrapper-list__item">
                    <h4>{t("Total to be paid")}</h4>
                    <p> <img
                        src={change ? selectedCurr.img : selectedCoin.img}
                        alt=""
                    />{" "}
                        {exchangeValue}</p>
                </div>
                <div className="line-p"></div>

                <div className="wrapper-list__item">
                    <h4>{t("Exchange rate")}</h4>
                    <p>{pair}</p>
                </div>
                <div className="line-p"></div>

                <div className="wrapper-list__item">
                    <h4>{t("Receive")}</h4>
                    <p>
                        <img
                            src={receiveImg}
                            alt=""
                        />{" "}
                        {preview[5]}
                    </p>
                </div>
            </div>
            <p ref={minimumEuros} className="errors">{t("The minimum transaction amount in equivalent must be") + ` ${minTransac} ${selectedCurr.type}`}</p>
            <div className="wrapper-buttons">
                <button onClick={closePopupPreview} className="form-default__cancel">
                    {t("Cancel")}
                </button>
                <button onClick={() => handleExchange()} className="form-default__submit">
                    {t("Exchange")}
                </button>
            </div>
        </div>
    )
}

export default Preview